import axios from "axios";
import React, { Fragment } from "react";
import { Dialog, Transition } from "@headlessui/react";
import { Navigate } from "react-router-dom";
import { ExclamationIcon, XIcon } from "@heroicons/react/outline";
import SettingPage from "./SettingPage";
import SettingPageedit from "./SettingPageedit";
import {toast} from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { DataContext } from "./Context/DataContext";
import { PaginationLinks } from "./helper";

const createData = [
  {
    heading: "New House Number",
    label: "House Number",
    type: "text",
    name: "house_number",
    url: "api/house/number/store",
  },
];

const COMPONENTDIDMOUNT = 'componentDiMount';

class HouseNumberlist extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      sidebarOpen: false,
      setSidebarOpen: false,
      showmsg: false,
      redirect: false,
      deletemsg: " Are you sure you want to delete the House Number ? ",
      deleteRedirect: false,
      logoutRedirect: false,
      cryptKey: "",
      deletealartmsg: false,
      houseNumber: [],
      editid: "",
      editData: [],
      try_again_name:"",
      housenumberModalopen: false,
      housenumberModalopenforedit: false,
      loader: "",
      overLay: "",
      links: [],
      search:"",
      page:1,
      searchContent: "",
      loader_status: false,
      try_again_status: false,
      main_content_status: false,
    };
  }

  setLoaderFunction = () => {

    this.setState({
        loader_status: true,
        try_again_status: false,
        main_content_status: false,
    });
};
closeLoaderFuncion = () => {
    this.setState({
        loader_status: false,
        try_again_status: false,
        main_content_status: true,
    });
};

enableTryAgain = () => {

    this.setState({
        loader_status: false,
        try_again_status: true,
        main_content_status: false,
    });
};

  close = async (e) => {
    this.setState({ sidebarOpen: false });
  };
  open = async (e) => {
    this.setState({ sidebarOpen: true });
  };

  delete = async (e) => {
    this.setState({ deletealartmsg: true });
    this.setState({ cryptKey: e });
  };

  Edit = async (e) => {
    this.setState({ editid: e });
    let token = localStorage.getItem("token");
    const ress = axios
      .get("api/house/number/edit/" + e, {
        headers: {
          authorization: `Bearer ${token}`,
          Accept: "application/json",
        },
      })
      .then((ress) => {
        if (ress.data.success) {
          this.state.editData.push({
            heading: "Update House Number",
            label: "House Number",
            type: "text",
            name: "name",
            url: "api/house/number/update",
            data: ress.data.HouseNumber.house_number,
          });
          this.setState({ editData: this.state.editData });
        }
      });
    this.setState({ housenumberModalopenforedit: true });
  };

  haldleDelete = async (e) => {
    if (this.state.deletealartmsg) {
      const token = localStorage.getItem("token");
      let id = this.state.cryptKey;
      //const id=this.setState({cryptKey:e});
      const resDelete = axios
        .get("api/house/number/delete/" + id, {
          headers: {
            authorization: `Bearer ${token}`,
            Accept: "application/json",
          },
        })
        .then((resDelete) => {
          if (resDelete.data.success) {
            this.setState({ deleteRedirect: true });
            this.setState({ deletealartmsg: false });
            toast.success("House Number  was Deleted successfully!");
          } else {
            this.setState({ deletemsg: resDelete.data.message });
          }
        });
    }
  };

  handleInputModal = (e) => {
    this.state.houseNumber = [];
    if (e) {
      this.setState({ openvendor: false });
      const token = localStorage.getItem("token");
      const res = axios
        .get("api/house/number/pagination", {
          headers: {
            authorization: `Bearer ${token}`,
            Accept: "application/json",
          },
        })
        .then((res) => {
          const houseNumber = res.data.houseNumber.data;
          this.setState({ houseNumber: houseNumber });
          let link = res.data.houseNumber.links;
          this.setState({ loader: "" });
          this.setState({ links: link });
          this.setState({ from: res.data.houseNumber.from });
          this.setState({ to: res.data.houseNumber.to });
          this.setState({ perpage: res.data.houseNumber.per_page });
          this.setState({ totalnoof: res.data.houseNumber.total });
          this.setState({ loader: "" });
          this.setState({ housenumberModalopen: false });
        });
    }
  };

  handleInputModaledit = (e) => {
    this.state.houseNumber = [];
    this.state.editData = [];
    if (e) {
      this.setState({ openvendor: false });
      const token = localStorage.getItem("token");
      const res = axios
        .get("api/house/number/pagination", {
          headers: {
            authorization: `Bearer ${token}`,
            Accept: "application/json",
          },
        })
        .then((res) => {
          const houseNumber = res.data.houseNumber.data;
          this.setState({ houseNumber: houseNumber });
          let link = res.data.houseNumber.links;
          //this.setState({ ManufacturerList: ManufacturerList });
          this.setState({ loader: "" });
          this.setState({ links: link });
          this.setState({ from: res.data.houseNumber.from });
          this.setState({ to: res.data.houseNumber.to });
          this.setState({ perpage: res.data.houseNumber.per_page });
          this.setState({ totalnoof: res.data.houseNumber.total });
          this.setState({ loader: "" });
          this.state.editData = [];
          this.setState({ housenumberModalopenforedit: false });
        });
    }
  };

  Search = (e) => {
    this.state.search = e.target.value;
    this.state.page = 1;
    this.setLoaderFunction();
    this.getDataForPagination();
  };

  
  async componentDidMount() {

    this.getDataForPagination();

  }


  async getDataForPagination() {
    try {
      this.setLoaderFunction()
      const token = localStorage.getItem("token");
      const { page, search } = this.state;
      const [

        { data: pagination },

      ] = await Promise.all([
        axios.get(`/api/house/number/pagination?page=${page}&search_v=${search}`, { headers: { authorization: `Bearer ${token}`, Accept: "application/json" } }),
      ]);


      this.setState({
      });
      const houseNumber = pagination.houseNumber.data;
      this.setState({ houseNumber: houseNumber });
      let link = pagination.houseNumber.links;
      //this.setState({ ManufacturerList: ManufacturerList });
      this.setState({ loader: "" });
      this.setState({ links: link });
      this.setState({ from: pagination.houseNumber.from });
      this.setState({ to: pagination.houseNumber.to });
      this.setState({ perpage: pagination.houseNumber.per_page });
      this.setState({ totalnoof: pagination.houseNumber.total });
      this.setState({ loader: "" });
      this.setState({ housenumberModalopen: false });
      this.closeLoaderFuncion();

    } catch (error) {
      this.state.try_again_name = COMPONENTDIDMOUNT;
      this.enableTryAgain();
    }
  }

  paginationFetch = async (e) => {
    if (e) {
      let url = new URL(e);
      let page = url.searchParams.get("page");
      this.state.page = page;
      this.setLoaderFunction();
      this.getDataForPagination();
    }
  };

  addhousenumber = (e) => {
    this.setState({ housenumberModalopen: true });
  };

  edithousenumber = () => {
    this.setState({ housenumberModalopenforedit: true });
  };

  closeedithousenumber = () => {
    this.setState({ housenumberModalopenforedit: false });
    this.state.editData = [];
  };

  closehousenumber = (e) => {
    this.setState({ housenumberModalopen: false });
  };

  logout = async (e) => {
    e.preventDefault();
    var token = localStorage.getItem("token");

    const res = await axios.get("api/logout", {
      headers: {
        authorization: `Bearer ${token}`,
        Accept: "application/json",
      },
    });

    if (res.data.success) {
      localStorage.removeItem("token");
      this.setState({ logoutRedirect: true }); 
    }
  };

  static contextType = DataContext;
  
  tryAgain = () => {
    switch (this.state.try_again_name) {
      case COMPONENTDIDMOUNT:
        this.getDataForPagination();
        break;
    }
  }
  render() {
    let token = localStorage.getItem("token");
    const { searchContent } = this.context

    if (searchContent !== this.state.searchContent) {

        this.Search(searchContent)
        this.state.searchContent = searchContent

    }
    if (this.state.deleteRedirect) {
      window.location.reload();
    }

    if (token == null) {
      return <Navigate to={"/Login"} />;
    }
    if (this.state.logoutRedirect) {
      return <Navigate to={"/Login"} />;
    }

    if (this.state.redirect) {
      //return <Navigate to={'/LeadCreate'} />
    }

    return (
      <>
        <div>
          {/* Static sidebar for desktop */}

           {/*loader_status------------------------------------------------------------------------*/}
           {this.state.loader_status && (
                    <div className="h-screen flex items-center justify-center bg-white bg-opacity-50 z-50">
                        <div className="bg-white p-4 rounded-md">
                            <div className="flex items-center justify-center">
                                <div
                                    className="animate-spin rounded-full border-4 border-l-blue-500 border-r-blue-500 border-t-blue-500 border-white-300 h-12 w-12"></div>
                            </div>
                            <p className="text-center mt-4">Loading...</p>
                        </div>
                    </div>
                )}
                {/*loader_status------------------------------------------------------------------------*/}

                {/*try_again_status-----------------------------------------------------------------------------*/}
                {this.state.try_again_status && (
                    <div className="h-screen flex items-center justify-center bg-white ">
                        <div className="flex flex-col items-center justify-center h-full">
                            <p className="text-red-500">{this.state.error_customize}</p>
                            <button
                                type="button"
                                onClick={this.tryAgain}
                                className="rounded-md bg-indigo-600 px-3.5 py-2.5 text-sm font-semibold text-white shadow-sm hover:bg-indigo-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600">
                                TryAgain
                            </button>
                        </div>
                    </div>
                )}
                {/*try_again_status-----------------------------------------------------------------------------*/}





                {this.state.main_content_status && (

          <div className="flex flex-col flex-1">
            <main className="flex-1">
              <div className="py-6">
                <div className="max-w-7xl mx-auto px-4 sm:px-6 md:px-8">
                  {/* Replace with your content */}
                  <div className="px-4 sm:px-6 lg:px-8">
                    <div className="sm:flex sm:items-center">
                      <div className="sm:flex-auto">
                        <h1 className="text-xl font-semibold text-gray-900">
                        House Number
                        </h1>
                        <p className="mt-2 text-sm text-gray-700">
                          A list of House Number
                        </p>
                      </div>

                      <div className="mt-4 sm:mt-0 sm:ml-16 sm:flex-none">
                        <button
                          onClick={this.addhousenumber}
                          type="button"
                          className="inline-flex items-center justify-center rounded-md border border-transparent bg-indigo-600 px-4 py-2 text-sm font-medium text-white shadow-sm hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2 sm:w-auto"
                        >
                          New House Number
                        </button>
                      </div>
                    </div>
                    <div className="mt-8 flex flex-col">
                      <div className="-my-2 -mx-4 overflow-x-auto sm:-mx-6 lg:-mx-8">
                        <div className="inline-block min-w-full py-2 align-middle md:px-6 lg:px-8">
                          <div className="overflow-hidden shadow ring-1 ring-black ring-opacity-5 md:rounded-lg">
                            <table
                              className={`min-w-full divide-y divide-gray-300 ${this.state.loader}`}
                            >
                              <thead className="bg-gray-50">
                                <tr>
                                  <th
                                    scope="col"
                                    className="py-3 pl-4 pr-3 text-center text-xs font-medium uppercase tracking-wide text-gray-500 sm:pl-6"
                                  >
                                    House Number
                                  </th>

                                  <th
                                    scope="col"
                                    className="px-3 py-3 text-center text-xs font-medium uppercase tracking-wide text-gray-500"
                                  >
                                    Action
                                  </th>
                                </tr>
                              </thead>
                              <tbody className="divide-y divide-gray-200 bg-white">
                                {this.state.houseNumber.map((person) => (
                                  <tr key={person.id}>
                                    <td className="whitespace-nowrap px-3 text-center py-4 text-sm text-gray-500">
                                      {person.house_number}
                                    </td>

                                    <td className="relative whitespace-nowrap py-4 pl-3 pr-4 text-center text-sm font-medium sm:pr-6">
                                      <span
                                        onClick={() =>
                                          this.Edit(person.id_crypt)
                                        }
                                        className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-green-100 text-green-800 cursor-pointer"
                                      >
                                        Edit
                                      </span>
                                      <span
                                        onClick={() =>
                                          this.delete(person.id_crypt)
                                        }
                                        className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-pink-100 text-pink-800 cursor-pointer"
                                      >
                                        Delete
                                      </span>
                                    </td>
                                  </tr>
                                ))}
                              </tbody>
                            </table>
                                 {/*pagination*/}

                              {/*part_three_pagination_links----------------------------------------------------------------------------------------------*/}
                              <PaginationLinks
                                from={this.state.from}
                                to={this.state.to}
                                total_no_of_item={this.state.total_no_of_project}
                                links={this.state.links}
                                paginationFetch={this.paginationFetch}
                              />
                              {/*part_three_pagination_links----------------------------------------------------------------------------------------------*/}

                              {/*pagination*/}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  {/*pagination*/}

                  {/*pagination/}

   {/* /End replace */}
                </div>
              </div>
            </main>
          </div>
                )}
        </div>

        {/*DeleteAlert */}
        <Transition.Root show={this.state.deletealartmsg} as={Fragment}>
          <Dialog
            as="div"
            className="fixed z-10 inset-0 overflow-y-auto"
            onClose={() =>
              this.setState({
                deletealartmsg: false,
                deletemsg:
                  " Are you sure you want to delete the House Number ? ",
              })
            }
          >
            <div className="flex items-end justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0">
              <Transition.Child
                as={Fragment}
                enter="ease-out duration-300"
                enterFrom="opacity-0"
                enterTo="opacity-100"
                leave="ease-in duration-200"
                leaveFrom="opacity-100"
                leaveTo="opacity-0"
              >
                <Dialog.Overlay className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />
              </Transition.Child>

              {/* This element is to trick the browser into centering the modal contents. */}
              <span
                className="hidden sm:inline-block sm:align-middle sm:h-screen"
                aria-hidden="true"
              >
                &#8203;
              </span>
              <Transition.Child
                as={Fragment}
                enter="ease-out duration-300"
                enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                enterTo="opacity-100 translate-y-0 sm:scale-100"
                leave="ease-in duration-200"
                leaveFrom="opacity-100 translate-y-0 sm:scale-100"
                leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
              >
                <div className="relative inline-block align-bottom bg-white rounded-lg px-4 pt-5 pb-4 text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:align-middle sm:max-w-lg sm:w-full sm:p-6">
                  <div className="hidden sm:block absolute top-0 right-0 pt-4 pr-4">
                    <button
                      type="button"
                      className="bg-white rounded-md text-gray-400 hover:text-gray-500 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
                      onClick={() =>
                        this.setState({
                          deletealartmsg: false,
                          deletemsg:
                            " Are you sure you want to delete the House Number ? ",
                        })
                      }
                    >
                      <span className="sr-only">Close</span>
                      <XIcon className="h-6 w-6" aria-hidden="true" />
                    </button>
                  </div>
                  <div className="sm:flex sm:items-start">
                    <div className="mx-auto flex-shrink-0 flex items-center justify-center h-12 w-12 rounded-full bg-red-100 sm:mx-0 sm:h-10 sm:w-10">
                      <ExclamationIcon
                        className="h-6 w-6 text-red-600"
                        aria-hidden="true"
                      />
                    </div>
                    <div className="mt-3 text-center sm:mt-0 sm:ml-4 sm:text-left">
                      <Dialog.Title
                        as="h3"
                        className="text-lg leading-6 font-medium text-gray-900"
                      >
                        Delete House Number
                      </Dialog.Title>
                      <div className="mt-2">
                        <p className="text-sm text-gray-500">
                          {this.state.deletemsg}
                        </p>
                      </div>
                    </div>
                  </div>
                  <div className="mt-5 sm:mt-4 sm:flex sm:flex-row-reverse">
                    <button
                      type="button"
                      className="w-full inline-flex justify-center rounded-md border border-transparent shadow-sm px-4 py-2 bg-red-600 text-base font-medium text-white hover:bg-red-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-red-500 sm:ml-3 sm:w-auto sm:text-sm"
                      onClick={this.haldleDelete}
                    >
                      Delete
                    </button>
                    <button
                      type="button"
                      className="mt-3 w-full inline-flex justify-center rounded-md border border-gray-300 shadow-sm px-4 py-2 bg-white text-base font-medium text-gray-700 hover:text-gray-500 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 sm:mt-0 sm:w-auto sm:text-sm"
                      onClick={() =>
                        this.setState({
                          deletealartmsg: false,
                          deletemsg:
                            " Are you sure you want to delete the House Number ? ",
                        })
                      }
                    >
                      Cancel
                    </button>
                  </div>
                </div>
              </Transition.Child>
            </div>
          </Dialog>
        </Transition.Root>
        {/*End DeleteAlert */}

        {/*Modal Create */}
        <Transition.Root show={this.state.housenumberModalopen} as={Fragment}>
          <Dialog
            as="div"
            className="relative z-10"
            onClose={this.closehousenumber}
          >
            <Transition.Child
              as={Fragment}
              enter="ease-out duration-300"
              enterFrom="opacity-0"
              enterTo="opacity-100"
              leave="ease-in duration-200"
              leaveFrom="opacity-100"
              leaveTo="opacity-0"
            >
              <div className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />
            </Transition.Child>

            <div className="fixed z-10 inset-0 overflow-y-auto">
              <div className="flex items-end lg:items-center  justify-center min-h-full p-4 text-center sm:p-0">
                <Transition.Child
                  as={Fragment}
                  enter="ease-out duration-300"
                  enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                  enterTo="opacity-100 translate-y-0 sm:scale-100"
                  leave="ease-in duration-200"
                  leaveFrom="opacity-100 translate-y-0 sm:scale-100"
                  leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                >
                  <Dialog.Panel className="relative bg-white rounded-lg px-4 pt-5 pb-4 text-left overflow-hidden shadow-xl transform transition-all sm:my-8  md:max-w-screen-sm  sm:w-full sm:p-6">
                    <div>
                      <SettingPage
                        ListtoCreate={createData}
                        handleInputwarehouseA={this.handleInputModal}
                      />
                    </div>
                  </Dialog.Panel>
                </Transition.Child>
              </div>
            </div>
          </Dialog>
        </Transition.Root>
        {/* Modal Create*/}

        {/** Modal Edit */}
        <Transition.Root
          show={this.state.housenumberModalopenforedit}
          as={Fragment}
        >
          <Dialog
            as="div"
            className="relative z-10"
            onClose={this.closeedithousenumber}
          >
            <Transition.Child
              as={Fragment}
              enter="ease-out duration-300"
              enterFrom="opacity-0"
              enterTo="opacity-100"
              leave="ease-in duration-200"
              leaveFrom="opacity-100"
              leaveTo="opacity-0"
            >
              <div className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />
            </Transition.Child>

            <div className="fixed z-10 inset-0 overflow-y-auto">
              <div className="flex items-end lg:items-center  justify-center min-h-full p-4 text-center sm:p-0">
                <Transition.Child
                  as={Fragment}
                  enter="ease-out duration-300"
                  enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                  enterTo="opacity-100 translate-y-0 sm:scale-100"
                  leave="ease-in duration-200"
                  leaveFrom="opacity-100 translate-y-0 sm:scale-100"
                  leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                >
                  <Dialog.Panel className="relative bg-white rounded-lg px-4 pt-5 pb-4 text-left overflow-hidden shadow-xl transform transition-all sm:my-8  md:max-w-screen-md lg:max-w-screen-lg sm:w-full sm:p-6">
                    <div>
                      <SettingPageedit
                        editID={this.state.editid}
                        ListtoEdit={this.state.editData}
                        handleInputwarehouseAE={this.handleInputModaledit}
                      />
                    </div>
                  </Dialog.Panel>
                </Transition.Child>
              </div>
            </div>
          </Dialog>
        </Transition.Root>
        {/** Modal Edit*/}
      </>
    );
  }
}

export default HouseNumberlist;
